import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SectionHeading } from "../common/SectionHeading";
import { Reveal } from "../common/Reveal";
import { IMAGES } from "../../lib/data";

export const PickYourFun = () => (
    <section data-testid="pick-your-fun-section" className="bg-paper tent-stripes-light py-24 md:py-32">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
            <SectionHeading
                chapter="02"
                kicker="The Treats"
                title="Pick Your Fun."
                copy="Two headliners. More acts on the way."
                testid="pick-your-fun-heading"
            />
            <div className="grid gap-6 md:grid-cols-3">
                <Reveal>
                    <Link to="/shop?kind=cotton_candy" data-testid="pick-cotton-candy-card" className="group block">
                        <motion.div
                            whileHover={{ scale: 1.04 }}
                            transition={{ type: "spring", stiffness: 180, damping: 16 }}
                            className="relative rounded-[2.5rem] overflow-hidden bg-white hover:shadow-[0_20px_60px_rgba(255,95,162,0.35)] transition-shadow duration-500"
                        >
                            <img src={IMAGES.cottonCandy} alt="Cotton candy" loading="lazy" className="aspect-[4/5] w-full object-cover" />
                            <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-black/70 to-transparent">
                                <p className="font-oswald uppercase text-3xl text-white">Cotton Candy</p>
                                <p className="text-sm text-pink-soft mt-1">Soft. Light. Freshly spun clouds.</p>
                            </div>
                        </motion.div>
                    </Link>
                </Reveal>
                <Reveal delay={0.1}>
                    <Link to="/shop?kind=popcorn" data-testid="pick-popcorn-card" className="group block">
                        <motion.div
                            whileHover={{ y: -10, rotate: -0.5 }}
                            transition={{ type: "spring", stiffness: 400, damping: 12 }}
                            className="relative rounded-[2.5rem] overflow-hidden bg-white"
                        >
                            <img src={IMAGES.popcorn} alt="Popcorn" loading="lazy" className="aspect-[4/5] w-full object-cover" />
                            <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-black/70 to-transparent">
                                <p className="font-oswald uppercase text-3xl text-white">Popcorn</p>
                                <p className="text-sm text-zinc-200 mt-1">Popped fresh. Gone fast.</p>
                            </div>
                        </motion.div>
                    </Link>
                </Reveal>
                <Reveal delay={0.2}>
                    <div data-testid="pick-slushies-card" className="relative rounded-[2.5rem] overflow-hidden bg-ink cursor-default">
                        <img src={IMAGES.slushie} alt="Slushies — coming soon" loading="lazy" className="aspect-[4/5] w-full object-cover grayscale opacity-60" />
                        <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                            <span className="rounded-full border-2 border-pink px-5 py-2 font-oswald uppercase tracking-[0.3em] text-xs text-pink rotate-[-4deg]">
                                Coming Soon
                            </span>
                            <p className="mt-5 font-oswald uppercase text-3xl text-white">Slushies</p>
                            <p className="text-sm text-zinc-400 mt-1">Ice cold. Worth the wait.</p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
